import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  detail: [],
};

// export const getLedgerDetail = createAsyncThunk("d/fetchD ", async ({ type, id }) => {
//   console.log(',', type)
//   console.log(',', id)

//   let updateType =
//     type == "purchase" ? "getPurchaseLedgersById" : "getSaleLedgersById";
//   return Repo.ledger({
//     request: {
//       method: updateType,
//       data: {
//         _id: id,
//       },
//     },
//   })
//     .then(({ data }) => data.response.data)
//     .catch((err) => console.log(err));
// });

export const getLedgerDetail = createAsyncThunk("d/fetchD", async ({ type, id }) => {
  console.log(',', type);
  console.log(',', id);

  let updateType =
    type === "purchase" ? "getPurchaseLedgersById" : "getSaleLedgersById";

  try {
    const { data } = await Repo.ledger({
      request: {
        method: updateType,
        data: {
          _id: id,
        },
      },
    });

    // Return the data once it's fetched
    return data.response.data;
  } catch (err) {
    console.log(err);
    throw err; // Re-throw the error so it can be handled by the calling function
  }
});

export const ledgerDetailSlice = createSlice({
  name: "ledgerDetail",
  initialState,

  reducers: {
    entryAdded: (state, action) => {
      const { entry, balance } = action.payload;
      state.detail = [{ ...entry, balance }, ...state.detail];
    },
    entryRemove: (state, action) => {
      const { entry } = action.payload;
      let found = state.detail.findIndex((item) => item.srNum == entry.srNum);
      state.detail.splice(found, 1);
    },

    clearLedgerDetail: (state, action) => {
      state.detail = [];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getLedgerDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLedgerDetail.fulfilled, (state, action) => {
      state.loading = false;
      let details = [];

      if (action.payload?.purchaseLedgers) {
        details = action.payload.purchaseLedgers;
      } else if (action.payload?.saleLedgers) {
        details = action.payload?.saleLedgers;
      }
      state.detail = details;
      state?.detail?.forEach((item) => {
        if (item.convertedDate) {
          item.convertedDate = moment
            .unix(item?.date / 1000)
            .format("YYYY-MM-DD");
        }
      });
      state.error = "";
    });
    builder.addCase(getLedgerDetail.rejected, (state, action) => {
      state.loading = false;
      state.detail = [];
      state.error = action.error.message;
    });
  },
});

export const { clearLedgerDetail, entryAdded, entryRemove } =
  ledgerDetailSlice.actions;

export default ledgerDetailSlice.reducer;
